import { Navigate, useLocation } from 'react-router-dom'
import SuperAdminHeader from '../Header/SuperAdminHeader';
import Header from '../Header/Header';

const ProtectedRoute = ({ user, children }) => {
    const { pathname } = useLocation();
    // redirect to main page
    if (!user) { return <Navigate to="/" /> }
    // redirect to kiosk path
    var pathLower = pathname.toLowerCase();
    if (user.Role === "SuperAdmin") {
        // include lead capture and exhibitor header
        return (
            <div>
                <SuperAdminHeader />
                <div>{children}</div>
            </div>
        );
    }
    else if (user.Role === "Admin") {
        // include lead capture header
        return (
            <div>
                <Header />
                <div>{children}</div>
            </div>
        );
    }
    return children
}

export default ProtectedRoute